import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { QuantitySelectorComponent } from './quantity-selector.component';
import { FormsModule } from '@angular/forms';
import { NgxMaskDirective } from "ngx-mask";

@NgModule({
    declarations: [
        QuantitySelectorComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        NgxMaskDirective
    ],
    exports: [
        QuantitySelectorComponent
    ]
})
export class QuantitySelectorModule { }
